import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import backgroundImage from './bg2.png';
import { utils } from '@ohif/core';
import { useAppConfig } from '@state';
import { Button,Input } from 'antd';
import { UserOutlined,LockOutlined } from '@ant-design/icons';
const { apiService } = utils;

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState(''); // 用于显示错误信息
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [appConfig, setAppConfig] = useAppConfig();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // 使用 FormData 构造请求参数
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    setLoading(true);

    try {
      const response = await apiService({
        uri: '/api/login',
        method: 'POST',
        data: formData, // 传递 FormData
        headers: {}, // FormData 不需要设置 Content-Type，浏览器会自动处理
      });
      // 处理服务器返回的响应
      if (response === '0') {
        setLoading(false);
        const user = { username };
        sessionStorage.setItem('user', btoa(JSON.stringify({ user })));

        // 提前计算默认的 thumbnailLocation
        const defaultThumbnailLocation = checkOrientation() === 'portrait' ? 'top' : 'right';
        // 获取 isUserSet 的值
        const isUserSet = localStorage.getItem('isUserSet');
        // 初始化 thumbnailLocation 为默认值
        let thumbnailLocation = defaultThumbnailLocation;

        // 如果 isUserSet 为 'true'
        if (isUserSet === 'true') {
          // 尝试从 localStorage 中获取 thumbnailLocation
          const storedThumbnailLocation = localStorage.getItem('thumbnailLocation');
          // 如果存储的值存在，则使用存储的值，否则使用默认值
          thumbnailLocation = storedThumbnailLocation || defaultThumbnailLocation;
        }

        // 将最终的 thumbnailLocation 存储到 localStorage 中
        localStorage.setItem('thumbnailLocation', thumbnailLocation);
        localStorage.setItem('page', 'start');
        navigate('/mobileworklist'); // 成功登录后跳转到工作列表页面
      } else if (response === '1') {
        setLoading(false);
        setErrorMessage('用户不存在');
      } else if (response === '2') {
        setLoading(false);
        setErrorMessage('密码错误');
      }
    } catch (error) {
      setLoading(false);
      console.error('登录请求失败:', error);
      setErrorMessage('登录失败，请稍后重试');
    }
  };

  const checkOrientation = () => {
    if (window.matchMedia('(orientation: portrait)').matches) {
      console.log('竖屏');
      return 'portrait';
    } else if (window.matchMedia('(orientation: landscape)').matches) {
      console.log('横屏');
      return 'landscape';
    }
  };

  return (
    <div
      className="main-page-box flex min-h-screen items-center justify-center"
       style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="w-full max-w-xl p-8">
        <h1
          className="mb-6 text-center text-4xl font-bold"
          style={{ color: '#4078ce' }}
        >
          云影像平台
        </h1>
        <div className='mobilelogin-wrap'>
          {errorMessage && <div className="mb-4 text-center text-red-500">{errorMessage}</div>}{' '}
          {/* 错误提示 */}
          <form onSubmit={handleSubmit}>
            <div className="mb-4 flex">
              <label
                htmlFor="username"
                className="mb-2 block text-gray-700"
              >
              </label>
              <Input
                type="text"
                id="username"
                prefix={<UserOutlined style={{ marginRight: '8px',color:'#666' }} />}
                style={{fontSize:'18px'}}
                size="large"
                value={username}
                onChange={e => setUsername(e.target.value)}
                className="w-full h-12 rounded-full border px-3 focus:outline-none focus:ring-2 focus:ring-blue-400 text-base"
                placeholder="请输入用户名"
                autoComplete="username"
                required
              />
            </div>
            <div className="mb-6 flex">
              <label
                htmlFor="password"
                className="mb-2 block text-gray-700"
              >
              </label>
              <Input
                type="password"
                id="password"
                prefix={<LockOutlined style={{ marginRight: '8px',color:'#666' }} />}
                style={{fontSize:'18px'}}
                size="large"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="w-full h-12 rounded-full border px-3  focus:outline-none focus:ring-2 focus:ring-blue-400 text-base"
                placeholder="请输入密码"
                autoComplete="current-password"
                required
              />
            </div>
            <Button
              htmlType="submit"
              loading={isLoading}
              size="large"
              style={{ backgroundColor: '#8cc7e0', color: '#fff' }}
              className="w-full h-12 rounded-full bg-blue-500 text-white transition duration-200 hover:bg-blue-600"
            >
              登录
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
